/**
 * Name: PPWD-LRSE-Call-For-Price
 * Author: PPWD
 * Description: Toggle call for price when product price is set to 0
 * Date: May 21, 2025
 */

function initVariantPriceWatcher(container = document) {
  const forms = container.querySelectorAll('form[action^="/cart/add"]');

  forms.forEach((form) => {
    const addToCartBtn = form.querySelector("[data-add-to-cart]");
    const callPriceBtn = form.querySelector(".call-for-price");

    if (!addToCartBtn || !callPriceBtn) return;

    function toggleButtons(price) {
      const productPrice = document.querySelector(
        ".product-block--price [data-product-price]"
      );
      const shopPayWrapper = form.querySelector(
        ".shopify-payment-button, .product__dynamic-checkout-buttons"
      );
      const otherPayments = form.querySelector(
        ".shopify-payment-terms.product__policies"
      );

      if (price === 0) {
        addToCartBtn.style.display = "none";
        callPriceBtn.style.display = "inline-block";
        productPrice.textContent = "Call for Pricing";
        shopPayWrapper.style.display = "none";
        otherPayments.style.display = "none";
      } else {
        addToCartBtn.style.display = "inline-block";
        callPriceBtn.style.display = "none";
        shopPayWrapper.style.display = "block";
        otherPayments.style.display = "block";
      }
    }

    function getSelectedVariantId() {
      const variantSelector = form.querySelector('[name="id"]');
      return variantSelector ? variantSelector.value : null;
    }

    function checkVariantPrice() {
      const variantId = getSelectedVariantId();
      if (!variantId) return;

      fetch(`/variants/${variantId}.js`)
        .then((res) => res.json())
        .then((variant) => {
          toggleButtons(variant.price);
        })
        .catch(console.error);
    }

    // Initial check
    checkVariantPrice();

    // Update on any form change
    form.addEventListener("change", checkVariantPrice);
  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", function () {
  initVariantPriceWatcher();

  // OPTIONAL: If you use modals (Quick View, etc.)
  // Watch for dynamic modal open events
  document.addEventListener("modal:opened", function (e) {
    const modalContent =
      e.detail?.modal || document.querySelector(".modal[open]");
    if (modalContent) {
      initVariantPriceWatcher(modalContent);
    }
  });

  // OR, fallback: observe DOM for dynamically added product forms
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelectorAll) {
          const hasProductForm = node.querySelector(
            'form[action^="/cart/add"]'
          );
          if (hasProductForm) {
            initVariantPriceWatcher(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
